import BasketOrderItem from "../../../entities/manhattan/basket/BasketOrderItem";
import { IBasketOrderItem } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";
import { BasketOrderItemCheckoutPriceFactory } from "./BasketOrderItemCheckoutPriceFactory";
import { BasketOrderItemPriceFactory } from "./BasketOrderItemPriceFactory";

export const BasketOrderItemFactory: IManhattanFactory = class BasketOrderItemFactory {

  static create(basketOrderItem: IBasketOrderItem) {
    const itemQuantity = basketOrderItem.quantity ? basketOrderItem.quantity : 1;
    return new BasketOrderItem(
      basketOrderItem.id,
      basketOrderItem.type,
      basketOrderItem.name,
      basketOrderItem.price ? BasketOrderItemPriceFactory.create(basketOrderItem.price, itemQuantity) : null,
      basketOrderItem.price?.isPaidOnCheckout ? BasketOrderItemCheckoutPriceFactory.create(basketOrderItem.price) : null,
      basketOrderItem.quantity,
      basketOrderItem.minConfigurationItemNumber,
      basketOrderItem.color,
      basketOrderItem.imagePath,
      basketOrderItem.inBundle,
      basketOrderItem.policyId,
      basketOrderItem.manufacturer,
      basketOrderItem.model,
      basketOrderItem.internet,
      basketOrderItem.availableColors ? basketOrderItem.availableColors : [],
      basketOrderItem.productColorsImages ? basketOrderItem.productColorsImages : [],
    );
  }

};
